<template>
    <CRow>
        <CCol col>
            <div style="width:100%; height: 80vh;">
                <ejs-grid ref='grid' :dataSource="data" :allowFiltering='true' :allowPaging="true" 
                          :allowResizing='true' :query='gridQuery' :toolbarClick='toolbarClick'
                          :allowExcelExport='true' :excelExportComplete='excelExportComplete'
                          :allowReordering='true' :allowSorting='true' :editSettings='editSettings' :toolbar='toolbar'
                          :pageSettings='pageSettings' :actionComplete='actionComplete' :actionBegin="actionBegin"
                          :actionFailure="actionFailure" :filterSettings='filterOptions' :queryCellInfo='customiseCell' width="100%" height="100%">
                    <e-columns>
                        <e-column field='triggerId' headerText='Id' width=120 :isPrimaryKey='true' textAlign='Left' :visible='false'></e-column>
                        <e-column field='clientId' headerText='Client' :validationRules="requiredRules" textAlign='Left' :visible='false' :index="1" width=200 :edit='clientParams' foreignKeyField='id' foreignKeyValue='name' :dataSource='clients' editType='dropdownedit'></e-column>
                        <e-column field='clientName' headerText='Client' textAlign='Left' width=200 type="string"></e-column>
                        <e-column field='stateId' headerText='Country' textAlign='Left' :validationRules="requiredRules" :visible='false' width=150 :edit='countryParams' foreignKeyField='id' foreignKeyValue='name' :dataSource='countries' editType='dropdownedit'></e-column>
                        <e-column field='stateName' headerText='Country' textAlign='Left' :visible='true' width=150 type="string"></e-column>
                        <e-column field='companyId' headerText='Company' textAlign='Left' :validationRules="requiredRules" width=210 :visible='false' :edit='companyParams' foreignKeyField='id' foreignKeyValue='name' :dataSource='companies' editType='dropdownedit'></e-column>
                        <e-column field='companyName' headerText='Company' textAlign='Left' width=210 type="string"></e-column>
                        <e-column field='utilityTypeId' headerText='Commodity' textAlign='Left' :validationRules="requiredRules" :visible='false' :index="1" width=150 :edit='utilitiesParams' foreignKeyField='utilityTypeId' foreignKeyValue='utilityTypeName' :dataSource='utilities' editType='dropdownedit'></e-column>
                        <e-column field='utilityTypeName' headerText='Commodity' textAlign='Left' :visible='false' width=150 type="string"></e-column>
                        <e-column field='productId' headerText='Product' textAlign='Left' :visible='false' :validationRules="requiredRules" width=150 :edit='productParams' foreignKeyField='id' foreignKeyValue='name' :dataSource='products' editType='dropdownedit'></e-column>
                        <e-column field='productName' headerText='Product' textAlign='Left' :visible='true' width=150 type="string"></e-column>
                        <e-column field='pricingAreaId' headerText='Price Area' :visible='false' width=120 :validationRules="requiredRules" foreignKeyField='id' foreignKeyValue='name' :edit='priceAreaParams' :dataSource='priceArea' editType='dropdownedit'></e-column>
                        <e-column field='pricingAreaName' headerText='Price Area' textAlign='Left' width=140 type="string"></e-column>
                        <e-column field='contractId' headerText='Contract' textAlign='Left' :visible='false' :validationRules="requiredRules" width=300 :edit='contractParams' foreignKeyField='id' foreignKeyValue='name' :dataSource='contracts' editType='dropdownedit'></e-column>
                        <e-column field='contractName' headerText='Contract' textAlign='Left' width=300 type="string"></e-column>
                        <e-column field='tradeablePeriodId' headerText='Watched Period' textAlign='Left' :visible='false' :validationRules="requiredRules" editType='dropdownedit' :edit='tradebalePeriodParams' foreignKeyField="id" foreignKeyValue='name' :dataSource='tradebalePeriods' width=130></e-column>
                        <e-column field='tradeablePeriodName' headerText='Period' textAlign='Left' width=130 type="string"></e-column>
                        <e-column field='triggerTypeId' headerText='Trigger Type' textAlign='Left' :visible='false' :validationRules="requiredRules" editType='dropdownedit' :edit='triggerTypeParams' foreignKeyField="id" foreignKeyValue='name' :dataSource='triggerTypes' width=150></e-column>
                        <e-column field='triggerTypeName' headerText='Trigger Type' textAlign='Left' :visible='true' width=150 type="string"></e-column>
                        <e-column field='triggerPrice' headerText='Trigger Price' textAlign='Left' :validationRules="percentageRules" type="number" format="n3" editType='numericedit' :edit='numericParams' width=150></e-column>
                        <e-column field='tolerance' headerText='Tolerance' textAlign='Left' :validationRules="percentageRules" type="number" format="n1" editType='numericedit' :edit='percentageParams' width=150></e-column>
                        <e-column field='statusDate' headerText='Live Date' textAlign='Left' :format='dateFormatOptions' type='date' width=150></e-column>

                        <e-column field='referenceTypeId' headerText='Reference Type' :visible='false' textAlign='Left' :validationRules="requiredRules" editType='dropdownedit' :edit='referenceTypeParams' foreignKeyField="id" foreignKeyValue='name' :dataSource='referenceTypes' width=150></e-column>
                        <e-column field='referenceTypeName' headerText='Reference Type' textAlign='Left' :visible='false' width=150 type="string"></e-column>

                        <e-column field='unit' headerText='Unit' :visible='false' width=150 type="string"></e-column>
                        <e-column field='riskManager' headerText='Risk Manager' :visible="false" width=150 type="string"></e-column>

                        <e-column field='triggerActions' headerText='Trigger Actions' :visible="false" width=150 type="string"></e-column>

                        <e-column headerText='Watched Window' :columns='dateColumns' :visible='false' textAlign="Center"></e-column>
                        <e-column field='applyUntilEnd' headerText='Apply until Default Deadline' displayAsCheckBox='true' :visible='false' :edit='checkboxParams' editType='booleanedit' type='boolean' width=120></e-column>
                        <e-column field='notifyOnSystem' headerText='Notify On System' defaultValue='true' displayAsCheckBox='true' :visible='false' :allowEditing="false" editType='booleanedit' type='boolean' width=120></e-column>
                        <e-column field='notifyEmailAddresses' headerText='Notify Email Addresses' multiline="true" defaultValue='RM@trioadvisory.com' :edit="multilineParams" :visible='false' width=120></e-column>

                    </e-columns>
                </ejs-grid>
            </div>
        </CCol>
    </CRow>
</template>

<script>
    import Vue from "vue";
    import { GridPlugin, Edit, Page, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey, CommandColumn } from "@syncfusion/ej2-vue-grids";
    import { DropDownList } from "@syncfusion/ej2-dropdowns";
    //  import { DialogUtility } from '@syncfusion/ej2-popups';
    import SyncHelper from '../../common/syncfusion';
    import { Query } from '@syncfusion/ej2-data';
    import gridOptions from '../../common/gridOptions'
    import dates from '../../common/dates'
    import urls from '../../common/urls';
    import apis from '../../common/network'
    import { DatePickerPlugin, DatePicker } from '@syncfusion/ej2-vue-calendars';
    import { CheckBoxPlugin, CheckBox } from "@syncfusion/ej2-vue-buttons";
    import { TextBox } from "@syncfusion/ej2-inputs";
    import { createSpinner, showSpinner, hideSpinner } from '@syncfusion/ej2-popups';

    //  Vue.use(DialogUtility);
    Vue.use(GridPlugin);

    let tradebalePeriodObj, tradebalePeriodElem, triggerTypeObj, triggerTypeElem, referenceTypeObj, referenceTypeElem, datePickerObj, elem, startDatePickerObj, startDateElem, checkboxElem, checkBoxObj;
    let dpUtilities, elUtilities, dpProducts, elProducts, multilineElem, multilineObj, dpPriceArea, elPriceArea;
    let dpClient, elClient, dpCountry, elCountry, dpCompany, elCompany, dpContract, elContract;
    export default {
        data() {
            return {
                triggerType: "DueLive",
                commands: [{ type: 'Edit', buttonOption: { iconCss: 'e-edit e-icons' } },
                { type: 'Delete', buttonOption: { iconCss: 'e-delete e-icons' } }],
                gridQuery: new Query().addParams("triggerType", "DueLive"),
                dateColumns: [
                    {
                        field: 'triggerStartDate',
                        headerText: 'Start Date',
                        width: 150,
                        visible: false,
                        textAlign: 'Left',
                        minWidth: 10,
                        format: { type: 'date', format: 'dd/MM/yyyy' },
                        type: 'date',
                        validationRules: { required: true, minlength: [(args) => { return this.dateInPast(args) }, 'Start date can not be in past'] },
                        edit: {
                            create: function () {
                                startDateElem = document.createElement('input');
                                return startDateElem;
                            },
                            read: () => {
                                return startDatePickerObj.value;
                            },
                            destroy: () => {
                                startDatePickerObj.destroy();
                            },
                            write: (args) => {
                                startDatePickerObj = new DatePicker({
                                    value: new Date(args.rowData[args.column.field]),
                                    floatLabelType: 'Always',
                                    format: 'dd/MM/yyyy',
                                    //sets the min.
                                    min: dates.addDays(new Date(), 1),
                                    placeholder: 'Start Date',
                                    firstDayOfWeek: 1,
                                });
                                startDatePickerObj.appendTo(startDateElem);
                            }
                        }
                    },
                    {
                        field: 'triggerEndDate',
                        headerText: 'End Date',
                        width: 150,
                        visible: false,
                        textAlign: 'Left',
                        minWidth: 10,
                        format: { type: 'date', format: 'dd/MM/yyyy' },
                        type: 'date',
                        validationRules: { required: true, minlength: [(args) => { return this.dateValidation(args) }, 'Start date can not be higher then end date'], maxLength: [(args) => { return this.dateEndInPast(args) }, 'End date can not be in past'] },
                        edit: {
                            create: function () {
                                elem = document.createElement('input');
                                return elem;
                            },
                            read: () => {
                                return datePickerObj.value;
                            },
                            destroy: () => {
                                datePickerObj.destroy();
                            },
                            write: (args) => {
                                datePickerObj = new DatePicker({
                                    value: new Date(args.rowData[args.column.field]),
                                    floatLabelType: 'Always',
                                    format: 'dd/MM/yyyy',
                                    //sets the min after the startdate.
                                    min: dates.addDays(new Date(), 1),
                                    placeholder: 'End Date',
                                    firstDayOfWeek: 1,
                                });
                                datePickerObj.appendTo(elem);
                            }
                        }
                    }
                ],
                utilities: SyncHelper.getDataManager("utils/utilities"),
                products: SyncHelper.getDataManager("utils/products"),
                clients: SyncHelper.getDataManager("utils/parentclients"),
                countries: SyncHelper.getDataManager("utils/clientStates"),
                companies: SyncHelper.getDataManager("utils/clientCompanies"),
                contracts: SyncHelper.getDataManager("utils/contracts"),
                referenceTypes: SyncHelper.getDataManager('Utils/referenceTypes'),
                triggerTypes: SyncHelper.getDataManager('Utils/triggerTypes'),
                priceArea: SyncHelper.getDataManager("utils/pricingContractAreas"),
                contractUnits: "",
                riskManager: "",
                checkPriceArea: false,
                wrapSettings: { wrapMode: 'Header' },
                tradebalePeriods: SyncHelper.getDataManager('Utils/contractTradeablePeriods'),
                dateFormatOptions: { type: 'date', format: 'dd/MM/yyyy' },
                data: SyncHelper.getDataManager("ContractTrigger"),
                clientParams: {
                    create: () => {
                        elClient = document.createElement('input');
                        return elClient;
                    },
                    read: () => {
                        return dpClient.value;
                    },
                    destroy: () => {
                        dpClient.destroy();
                    },
                    write: (args) => {
                        dpClient = new DropDownList({
                            dataSource: this.clients,
                            fields: { text: args.column.foreignKeyValue, value: args.column.foreignKeyField },
                            value: ((args.foreignKeyData && args.foreignKeyData[0]) ? args.foreignKeyData[0][args.column.foreignKeyField] : null),
                            placeholder: 'Client',
                            floatLabelType: 'Always',
                            allowFiltering: true,
                            showClearButton: true,
                            enabled: (args.foreignKeyData ? false : true),
                            change: (args) => {
                                dpCountry.enabled = true;
                                let tempQuery = new Query().addParams("clientId", dpClient.value);
                                dpCountry.query = tempQuery;
                                dpCountry.text = null;
                                dpCountry.dataBind();
                            }
                        });
                        dpClient.appendTo(elClient);
                    }
                },
                countryParams: {
                    create: () => {
                        elCountry = document.createElement('input');
                        return elCountry;
                    },
                    read: () => {
                        return dpCountry.value;
                    },
                    destroy: () => {
                        dpCountry.destroy();
                    },
                    write: (args) => {
                        dpCountry = new DropDownList({
                            dataSource: this.countries,
                            fields: { text: args.column.foreignKeyValue, value: args.column.foreignKeyField },
                            value: ((args.foreignKeyData && args.foreignKeyData[0]) ? args.foreignKeyData[0][args.column.foreignKeyField] : null),
                            placeholder: 'Country',
                            floatLabelType: 'Always',
                            allowFiltering: true,
                            showClearButton: true,
                            enabled: false,
                            change: (args) => {
                                dpCompany.enabled = true;
                                let tempQuery = new Query().addParams("clientId", dpClient.value).addParams("stateId", dpCountry.value)
                                dpCompany.query = tempQuery;
                                dpCompany.text = null;
                                dpCompany.dataBind();
                            }
                        });
                        dpCountry.appendTo(elCountry);
                    }
                },
                priceAreaParams: {
                    create: () => {
                        elPriceArea = document.createElement('input');
                        return elPriceArea;

                    },
                    read: () => {
                        return dpPriceArea.value;

                    },
                    destroy: () => {
                        dpPriceArea.destroy();
                    },
                    write: (args) => {
                        dpPriceArea = new DropDownList({
                            dataSource: this.priceArea,
                            query: new Query().addParams("contractId", args.rowData.contractId),
                            fields: { text: args.column.foreignKeyValue, value: args.column.foreignKeyField },
                            value: ((args.foreignKeyData && args.foreignKeyData[0]) ? args.foreignKeyData[0][args.column.foreignKeyField] : null),
                            placeholder: 'Price Area',
                            floatLabelType: 'Always',
                            allowFiltering: true,
                            showClearButton: true,
                            enabled: false,
                            change: (args) => {

                            }
                        });

                        dpPriceArea.appendTo(elPriceArea);
                    }
                },
                companyParams: {
                    create: () => {
                        elCompany = document.createElement('input');
                        return elCompany;
                    },
                    read: () => {
                        return dpCompany.value;
                    },
                    destroy: () => {
                        dpCompany.destroy();
                    },
                    write: (args) => {
                        dpCompany = new DropDownList({
                            dataSource: this.companies,
                            query: new Query().addParams("clientId", args.rowData.clientId).addParams("stateId", args.rowData.stateId).addParams("companyId", args.rowData.companyId),
                            enabled: false,
                            fields: { text: args.column.foreignKeyValue, value: args.column.foreignKeyField },
                            value: ((args.foreignKeyData && args.foreignKeyData[0]) ? args.foreignKeyData[0][args.column.foreignKeyField] : null),
                            placeholder: 'Company',
                            floatLabelType: 'Always',
                            allowFiltering: true,
                            showClearButton: true,
                            change: (args) => {
                                dpContract.enabled = true;
                                let tempQuery = new Query().addParams("productId", dpProducts.value).addParams("companyId", dpCompany.value)
                                dpContract.query = tempQuery;
                                dpContract.text = null;
                                dpContract.dataBind();
                            }
                        });
                        dpCompany.appendTo(elCompany);
                    }
                },
                contractParams: {
                    create: () => {
                        elContract = document.createElement('input');
                        return elContract;
                    },
                    read: () => {
                        return dpContract.value;
                    },
                    destroy: () => {
                        dpContract.destroy();
                    },
                    write: (args) => {
                        dpContract = new DropDownList({
                            enabled: false,
                            dataSource: this.contracts,
                            query: new Query().addParams("productId", args.rowData.productId).addParams("companyId", args.rowData.companyId),
                            fields: { text: args.column.foreignKeyValue, value: args.column.foreignKeyField },
                            value: ((args.foreignKeyData && args.foreignKeyData[0]) ? args.foreignKeyData[0][args.column.foreignKeyField] : null),
                            placeholder: 'Contract',
                            floatLabelType: 'Always',
                            allowFiltering: true,
                            showClearButton: true,
                            change: (args) => {
                                tradebalePeriodObj.enabled = true;
                                let tempQuery = new Query().addParams("contractId", dpContract.value);
                                tradebalePeriodObj.query = tempQuery;
                                tradebalePeriodObj.text = null;
                                tradebalePeriodObj.dataBind();
                                if (dpContract.value != null) {
                                    this.fetchUnit(dpContract.value);
                                }


                                dpPriceArea.query = tempQuery;
                                dpPriceArea.text = null;
                                dpPriceArea.requiredRules = { required: false };
                                dpPriceArea.dataBind();
                                this.fetchCheckPrice(dpContract.value, null);
                            }
                        });
                        dpContract.appendTo(elContract);
                    }
                },
                utilitiesParams: {
                    create: () => {
                        elUtilities = document.createElement('input');
                        return elUtilities;
                    },
                    read: () => {
                        return dpUtilities.value;
                    },
                    destroy: () => {
                        dpUtilities.destroy();
                    },
                    write: (args) => {
                        dpUtilities = new DropDownList({
                            dataSource: this.utilities,
                            fields: {
                                text: args.column.foreignKeyValue,
                                value: args.column.foreignKeyField
                            },
                            value: ((args.foreignKeyData && args.foreignKeyData[0]) ? args.foreignKeyData[0][args.column.foreignKeyField] : null),
                            // index: 0,
                            placeholder: 'Commodity',
                            floatLabelType: 'Always',
                            allowFiltering: true,
                            showClearButton: true,
                            enabled: (args.foreignKeyData ? false : true),
                            change: () => {
                                dpProducts.enabled = true;
                                let tempQuery = new Query().where('utilityTypeId', 'equal', dpUtilities.value);
                                dpProducts.query = tempQuery;
                                dpProducts.text = null;
                                dpProducts.dataBind();
                            },
                        });
                        dpUtilities.appendTo(elUtilities);
                    }
                },
                productParams: {
                    create: () => {
                        elProducts = document.createElement('input');
                        return elProducts;
                    },
                    read: () => {
                        return dpProducts.value;
                    },
                    destroy: () => {
                        dpProducts.destroy();
                    },
                    write: (args) => {
                        dpProducts = new DropDownList({
                            enabled: false,
                            dataSource: this.products,
                            fields: {
                                text: args.column.foreignKeyValue,
                                value: args.column.foreignKeyField
                            },
                            value: ((args.foreignKeyData && args.foreignKeyData[0]) ? args.foreignKeyData[0][args.column.foreignKeyField] : null),
                            placeholder: 'Product',
                            floatLabelType: 'Always',
                            allowFiltering: true,
                            showClearButton: true,
                            change: (args) => {
                                dpContract.enabled = true;
                                let tempQuery = new Query().addParams("productId", dpProducts.value).addParams("companyId", dpCompany.value)
                                dpContract.query = tempQuery;
                                dpContract.text = null;
                                dpContract.dataBind();
                            }
                        });
                        dpProducts.appendTo(elProducts);
                    }
                },
                tradebalePeriodParams: {
                    create: () => {
                        tradebalePeriodElem = document.createElement('input');
                        return tradebalePeriodElem;
                    },
                    read: () => {
                        return tradebalePeriodObj.value;
                    },
                    destroy: () => {
                        tradebalePeriodObj.destroy();
                    },
                    write: (args) => {
                        tradebalePeriodObj = new DropDownList({
                            query: new Query().addParams("contractId", args.rowData.contractId),
                            dataSource: this.tradebalePeriods,
                            fields: { text: args.column.foreignKeyValue, value: args.column.foreignKeyField },
                            value: ((args.foreignKeyData && args.foreignKeyData[0]) ? args.foreignKeyData[0][args.column.foreignKeyField] : null),
                            placeholder: 'Tradeable Period',
                            floatLabelType: 'Always',
                            allowFiltering: true,
                            showClearButton: true,
                            change: (args) => {
                                if (args.value != null) {
                                    apis.protectedApi(`${urls.apiBaseUrl}ContractTrigger/PeriodDeadline/${args.value}`).then(it => {

                                        if (checkBoxObj.checked) {

                                            datePickerObj.value = it.data.lastDay;
                                        }
                                        startDatePickerObj.max = it.data.lastDay;
                                        datePickerObj.max = it.data.lastDay;
                                    }).catch(
                                        response => {
                                            var message = response.response.data.message != undefined ? response.response.data.message : "Error invoking service,please contact support";
                                            gridOptions.errorAlert("Error: " + message);
                                        }
                                    );
                                }
                            }
                        });
                        tradebalePeriodObj.appendTo(tradebalePeriodElem);
                    }
                },
                referenceTypeParams: {
                    create: () => {
                        referenceTypeElem = document.createElement('input');
                        return referenceTypeElem;
                    },
                    read: () => {
                        return referenceTypeObj.value;
                    },
                    destroy: () => {
                        referenceTypeObj.destroy();
                    },
                    write: (args) => {
                        referenceTypeObj = new DropDownList({
                            dataSource: this.referenceTypes,
                            fields: { text: args.column.foreignKeyValue, value: args.column.foreignKeyField },
                            value: ((args.foreignKeyData && args.foreignKeyData[0]) ? args.foreignKeyData[0][args.column.foreignKeyField] : null),
                            placeholder: 'Reference Type',
                            floatLabelType: 'Always',
                            allowFiltering: true,
                            showClearButton: true,
                        });
                        referenceTypeObj.appendTo(referenceTypeElem);
                    }
                },
                triggerTypeParams: {
                    create: () => {
                        triggerTypeElem = document.createElement('input');
                        return triggerTypeElem;
                    },
                    read: () => {
                        return triggerTypeObj.value;
                    },
                    destroy: () => {
                        triggerTypeObj.destroy();
                    },
                    write: (args) => {
                        triggerTypeObj = new DropDownList({
                            cssClass: ((args.foreignKeyData && args.foreignKeyData[0]) ? args.foreignKeyData[0][args.column.foreignKeyValue] == 'Lower' ? 'greenBox' : 'redBox' : null),
                            dataSource: this.triggerTypes,
                            fields: { text: args.column.foreignKeyValue, value: args.column.foreignKeyField },
                            value: ((args.foreignKeyData && args.foreignKeyData[0]) ? args.foreignKeyData[0][args.column.foreignKeyField] : null),
                            placeholder: 'Trigger Type',
                            floatLabelType: 'Always',
                            allowFiltering: true,
                            showClearButton: true,
                            change: (args) => {
                                if (args.itemData.name == 'Lower') {
                                    args.element.parentElement.classList.remove('redBox');
                                    args.element.parentElement.classList.add('greenBox');
                                } else {
                                    args.element.parentElement.classList.remove('greenBox');
                                    args.element.parentElement.classList.add('redBox');
                                }
                            }
                        });
                        triggerTypeObj.appendTo(triggerTypeElem);

                    }
                },
                checkboxParams: {
                    create: function () {
                        checkboxElem = document.createElement('input');
                        return checkboxElem;
                    },
                    read: () => {
                        return checkBoxObj.checked;
                    },
                    destroy: () => {
                        checkBoxObj.destroy();
                    },
                    write: (args) => {
                        this.endDate = document.getElementsByName("triggerEndDate")[0];
                        checkBoxObj = new CheckBox({
                            cssClass: 'e-primary',
                            checked: args.rowData[args.column.field],
                            disabled: false,
                            //value: args.rowData[args.column.field],
                            label: "Apply until End Date",
                            change: (args) => {
                                if (args.checked && tradebalePeriodObj.value != undefined) {
                                    apis.protectedApi(`${urls.apiBaseUrl}ContractTrigger/PeriodDeadline/${tradebalePeriodObj.value}`).then(it => {
                                        datePickerObj.value = it.data.lastDay;
                                    }
                                    ).catch(
                                        response => {
                                            var message = response.response.data.message != undefined ? response.response.data.message : "Error invoking service,please contact support";
                                            gridOptions.errorAlert("Error: " + message);
                                        }
                                    );
                                }
                                if (args.checked == true) {
                                    datePickerObj.enabled = false;
                                } else {
                                    datePickerObj.enabled = true;
                                }
                            }
                        });
                        checkBoxObj.appendTo(checkboxElem);
                    }
                },
                multilineParams: {
                    create: function () {
                        multilineElem = document.createElement("textarea");
                        return multilineElem;
                    },
                    read: () => {
                        return multilineObj.value;
                    },
                    destroy: () => {
                        multilineObj.destroy();
                    },
                    write: args => {
                        multilineObj = new TextBox({
                            value: args.rowData["notifyEmailAddresses"],
                            floatLabelType: "Always",
                            placeholder: 'Notify Email Addresses',
                            multiline: true,

                        });
                        multilineObj.appendTo(multilineElem);
                    }
                },
                pageSettings: gridOptions.pageSettings,
                editSettings: {
                    showConfirmDialog: true,
                    showDeleteConfirmDialog: true,
                    allowEditing: this.$store.state.permissions["Permissions.Triggers.Update"],
                    allowAdding: this.$store.state.permissions["Permissions.Triggers.Create"],
                    allowDeleting: this.$store.state.permissions["Permissions.Triggers.Delete"],
                    mode: 'Dialog'
                },
                numericParams: {
                    params: {
                        validateDecimalOnType: true,
                        decimals: 3,
                        format: "n3"
                    }
                },
                percentageParams: {
                    params: {
                        validateDecimalOnType: true,
                        decimals: 1,
                        format: "n1"
                    }
                },
                toolbar: ['Add', 'Edit', 'Delete', 'ExcelExport'],
                requiredRules: { required: true },
                percentageRules: { required: true, number: true },
                nameRules: { required: true, maxLength: 50 },
                editparams: { params: { popupHeight: '300px' } },
                filterOptions: gridOptions.filterSettings,
            };
        },
        mounted() {
            createSpinner({
                target: document.getElementById('mainSpinner'),
                width: '50',
                type: 'Material',
                label: 'Loading data...',
                cssClass: 'loadingPoup'
            });
        },
        methods: {

            dateValidation: function (args) {
                return startDatePickerObj.value <= datePickerObj.value;
            },
            dateInPast: function (args) {

                if (args.element.defaultValue != args.value) {
                    const timeElapsed = Date.now();
                    const today = new Date(timeElapsed);
                    today.toUTCString();
                    return startDatePickerObj.value > today;

                } else {

                    return startDatePickerObj.value;
                }
            },
            dateEndInPast: function (args) {
                if (args.element.defaultValue != args.value) {
                    const timeElapsed = Date.now();
                    const today = new Date(timeElapsed);
                    today.toUTCString();
                    return datePickerObj.value > today;
                } else {
                    return datePickerObj.value;
                }
            },
            toolbarClick(args) {
                if (args.item.id.includes('excelexport')) {
                    this.$refs.grid.getColumns()[4].visible = false;
                    this.$refs.grid.getColumns()[10].visible = false;
                    this.$refs.grid.getColumns()[16].visible = false;

                    this.$refs.grid.getColumns()[5].visible = true;
                    this.$refs.grid.getColumns()[11].visible = true;
                    this.$refs.grid.getColumns()[17].visible = true;
                    this.$refs.grid.getColumns()[22].visible = true;
                }
                gridOptions.excelExport(args, "Due Live Triggers.xlsx", this.$refs);
            },
            excelExportComplete(args) {
                this.$refs.grid.hideSpinner();
                this.$refs.grid.getColumns()[4].visible = true;
                this.$refs.grid.getColumns()[10].visible = true;
                this.$refs.grid.getColumns()[16].visible = true;

                this.$refs.grid.getColumns()[5].visible = false;
                this.$refs.grid.getColumns()[11].visible = false;
                this.$refs.grid.getColumns()[17].visible = false;
                this.$refs.grid.getColumns()[22].visible = false;
            },

            actionBegin(args) {
                gridOptions.actionBegin(args);
                if (args.requestType == 'save') {
                    showSpinner(document.getElementById('mainSpinner'));

                }
                if (args.requestType == 'refresh') {
                    hideSpinner(document.getElementById('mainSpinner'));


                }
                if ((args.requestType === 'beginEdit' || args.requestType === 'add')) {

                    this.fetchCheckPrice(args.rowData.contractId, args.requestType);

                    for (var i = 0; i < this.$refs.grid.getColumns().length; i++) {
                        if (this.$refs.grid.getColumns()[i].headerText == "Apply until Default Deadline") {
                            this.$refs.grid.getColumns()[i].visible = true;
                        } else if (this.$refs.grid.getColumns()[i].field == "triggerActions") {
                            this.$refs.grid.getColumns()[i].visible = false;
                        } else if (this.$refs.grid.getColumns()[i].field == "triggerStatus") {
                            this.$refs.grid.getColumns()[i].visible = false;
                        } else if (this.$refs.grid.getColumns()[i].field == "applyUntilEnd") {
                            this.$refs.grid.getColumns()[i].visible = true;
                        } else if (this.$refs.grid.getColumns()[i].field == "notifyOnSystem") {
                            this.$refs.grid.getColumns()[i].visible = true;
                        } else if (this.$refs.grid.getColumns()[i].field == "notifyEmailAddresses") {
                            this.$refs.grid.getColumns()[i].visible = true;
                        } else if (this.$refs.grid.getColumns()[i].field == "utilityTypeId") {
                            this.$refs.grid.getColumns()[i].visible = true;
                        } else if (this.$refs.grid.getColumns()[i].field == "statusDate") {
                            this.$refs.grid.getColumns()[i].visible = false;
                        } else if (this.$refs.grid.getColumns()[i].field == "tradeablePeriodName") {
                            this.$refs.grid.getColumns()[i].visible = false;
                        } else if (this.$refs.grid.getColumns()[i].field == "tradeablePeriodId") {
                            this.$refs.grid.getColumns()[i].visible = true;
                        } else if (this.$refs.grid.getColumns()[i].field == "riskManager") {
                            this.$refs.grid.getColumns()[i].visible = false;
                        } else if (this.$refs.grid.getColumns()[i].field == "referenceTypeId") {
                            this.$refs.grid.getColumns()[i].visible = true;
                        } else if (this.$refs.grid.getColumns()[i].field == "triggerStartDate") {
                            this.$refs.grid.getColumns()[i].visible = true;
                        } else if (this.$refs.grid.getColumns()[i].field == "triggerEndDate") {
                            this.$refs.grid.getColumns()[i].visible = true;
                        } else if (this.$refs.grid.getColumns()[i].field == "companyName") {
                            this.$refs.grid.getColumns()[i].visible = false;
                        } else if (this.$refs.grid.getColumns()[i].field == "companyId") {
                            this.$refs.grid.getColumns()[i].visible = true;
                        } else if (this.$refs.grid.getColumns()[i].field == "contractId") {
                            this.$refs.grid.getColumns()[i].visible = true;
                        } else if (this.$refs.grid.getColumns()[i].field == "contractName") {
                            this.$refs.grid.getColumns()[i].visible = false;
                        } else if (this.$refs.grid.getColumns()[i].field == "clientId") {
                            this.$refs.grid.getColumns()[i].visible = true;
                        } else if (this.$refs.grid.getColumns()[i].field == "clientName") {
                            this.$refs.grid.getColumns()[i].visible = false;
                        } else if (this.$refs.grid.getColumns()[i].field == "stateId") {
                            this.$refs.grid.getColumns()[i].visible = true;
                        } else if (this.$refs.grid.getColumns()[i].field == "stateName") {
                            this.$refs.grid.getColumns()[i].visible = false;
                        } else if (this.$refs.grid.getColumns()[i].field == "productId") {
                            this.$refs.grid.getColumns()[i].visible = true;
                        } else if (this.$refs.grid.getColumns()[i].field == "productName") {
                            this.$refs.grid.getColumns()[i].visible = false;
                        } else if (this.$refs.grid.getColumns()[i].field == "triggerTypeId") {
                            this.$refs.grid.getColumns()[i].visible = true;
                        } else if (this.$refs.grid.getColumns()[i].field == "triggerTypeName") {
                            this.$refs.grid.getColumns()[i].visible = false;
                        } else if (this.$refs.grid.getColumns()[i].field == "pricingAreaId") {
                            this.$refs.grid.getColumns()[i].visible = true;
                        } else if (this.$refs.grid.getColumns()[i].field == "pricingAreaName") {
                            this.$refs.grid.getColumns()[i].visible = false;
                        }
                    }
                }
            },
            actionComplete(args) {
                gridOptions.actionComplete(args, this.$refs);

                if ((args.requestType === 'beginEdit' || args.requestType === 'add')) {
                    var applyEnd = args.rowData.applyUntilEnd;
                    if (applyEnd == true) {

                        datePickerObj.enabled = false;
                    }

                    this.contractUnits = args.rowData.unit;
                    args.dialog.height = "80%";
                    args.dialog.width = "50%";
                    let rows = args.form.querySelectorAll("tr");
                    for (var i = 0; i < rows.length; i = i + 2) {
                        if (rows.length > i + 1) {
                            rows[i].appendChild(
                                args.form.querySelectorAll("tr")[i + 1].cells[0]
                            );
                        }
                    }

                    for (var i = 0; i < this.$refs.grid.getColumns().length; i++) {
                        if (this.$refs.grid.getColumns()[i].headerText == "Apply until Default Deadline") {
                            this.$refs.grid.getColumns()[i].visible = false;
                        } else if (this.$refs.grid.getColumns()[i].field == "triggerActions") {
                            this.$refs.grid.getColumns()[i].visible = false;// changed for now as there is not enough space in the grid
                        } else if (this.$refs.grid.getColumns()[i].field == "triggerStatus") {
                            this.$refs.grid.getColumns()[i].visible = true;
                        } else if (this.$refs.grid.getColumns()[i].field == "applyUntilEnd") {
                            this.$refs.grid.getColumns()[i].visible = false;
                        } else if (this.$refs.grid.getColumns()[i].field == "notifyOnSystem") {
                            this.$refs.grid.getColumns()[i].visible = false;
                        } else if (this.$refs.grid.getColumns()[i].field == "notifyEmailAddresses") {
                            this.$refs.grid.getColumns()[i].visible = false;
                        } else if (this.$refs.grid.getColumns()[i].field == "utilityTypeId") {
                            this.$refs.grid.getColumns()[i].visible = false;
                        } else if (this.$refs.grid.getColumns()[i].field == "statusDate") {
                            this.$refs.grid.getColumns()[i].visible = true;
                        } else if (this.$refs.grid.getColumns()[i].field == "tradeablePeriodName") {
                            this.$refs.grid.getColumns()[i].visible = true;
                        } else if (this.$refs.grid.getColumns()[i].field == "tradeablePeriodId") {
                            this.$refs.grid.getColumns()[i].visible = false;
                            tradebalePeriodObj.value = args.rowData.tradeablePeriodId;
                        } else if (this.$refs.grid.getColumns()[i].field == "riskManager") {
                            this.$refs.grid.getColumns()[i].visible = false;// changed for now as there is not enough space in the grid
                        } else if (this.$refs.grid.getColumns()[i].field == "referenceTypeId") {
                            this.$refs.grid.getColumns()[i].visible = false;
                        } else if (this.$refs.grid.getColumns()[i].field == "triggerStartDate") {
                            this.$refs.grid.getColumns()[i].visible = false;
                        } else if (this.$refs.grid.getColumns()[i].field == "triggerEndDate") {
                            this.$refs.grid.getColumns()[i].visible = false;
                        } else if (this.$refs.grid.getColumns()[i].field == "companyId") {
                            this.$refs.grid.getColumns()[i].visible = false;
                            dpCompany.value = args.rowData.companyId;
                        } else if (this.$refs.grid.getColumns()[i].field == "companyName") {
                            this.$refs.grid.getColumns()[i].visible = true;
                        } else if (this.$refs.grid.getColumns()[i].field == "contractId") {
                            this.$refs.grid.getColumns()[i].visible = false;
                            dpContract.value = args.rowData.contractId;
                        } else if (this.$refs.grid.getColumns()[i].field == "contractName") {
                            this.$refs.grid.getColumns()[i].visible = true;
                        } else if (this.$refs.grid.getColumns()[i].field == "clientId") {
                            this.$refs.grid.getColumns()[i].visible = false;
                        } else if (this.$refs.grid.getColumns()[i].field == "clientName") {
                            this.$refs.grid.getColumns()[i].visible = true;
                        } else if (this.$refs.grid.getColumns()[i].field == "stateId") {
                            this.$refs.grid.getColumns()[i].visible = true;
                        } else if (this.$refs.grid.getColumns()[i].field == "stateName") {
                            this.$refs.grid.getColumns()[i].visible = false;
                        } else if (this.$refs.grid.getColumns()[i].field == "productId") {
                            this.$refs.grid.getColumns()[i].visible = true;
                        } else if (this.$refs.grid.getColumns()[i].field == "productName") {
                            this.$refs.grid.getColumns()[i].visible = false;
                        } else if (this.$refs.grid.getColumns()[i].field == "triggerTypeId") {
                            this.$refs.grid.getColumns()[i].visible = true;
                        } else if (this.$refs.grid.getColumns()[i].field == "triggerTypeName") {
                            this.$refs.grid.getColumns()[i].visible = false;
                        } else if (this.$refs.grid.getColumns()[i].field == "pricingAreaId") {
                            this.$refs.grid.getColumns()[i].visible = false;
                        } else if (this.$refs.grid.getColumns()[i].field == "pricingAreaName") {
                            this.$refs.grid.getColumns()[i].visible = true;
                        }

                    }
                    if (args.requestType != 'add') {
                        this.contractUnits = args.rowData.unit;
                        args.form[18].value = args.form[18].value + " [" + this.contractUnits + "]";
                        args.form[20].value = args.form[20].value + "%";
                    }

                    args.form[18].addEventListener("focusout", e => {
                        if (e.target.classList.contains("e-numerictextbox")) {

                            if (this.contractUnits != undefined) {
                                e.target.value = e.target.value + " [" + this.contractUnits + "]";
                            }
                        }
                    });

                    if (args.requestType === 'beginEdit') {

                        dpClient.value = args.rowData.clientId;
                        dpClient.text = args.rowData.clientName;

                        dpCompany.value = args.rowData.companyId;
                        dpCompany.text = args.rowData.companyName;

                        dpContract.value = args.rowData.contractId;
                        dpContract.text = args.rowData.contractName;

                        dpPriceArea.value = args.rowData.pricingAreaId;
                        dpPriceArea.text = args.rowData.pricingAreaName;


                    }

                    args.form[20].addEventListener("focusout", e => {
                        if (e.target.classList.contains("e-numerictextbox")) {
                            e.target.value = e.target.value + "%";
                        }
                    });
                }
            },
            actionFailure(args) {
                gridOptions.actionFailure(args);
                hideSpinner(document.getElementById('mainSpinner'));
            },
            customiseCell: function (args) {

                if (args.column.field === 'triggerTypeName') {
                    if (args.data['triggerTypeName'] == 'Lower') {
                        args.cell.classList.add('greenBox');
                    } else {
                        args.cell.classList.add('redBox');
                    }
                } else if (args.column.field === 'triggerPrice') {
                    args.cell.textContent = args.cell.textContent + " [" + args.data['unit'] + "]";
                } else if (args.column.field === 'tolerance') {
                    args.cell.textContent = args.cell.textContent + "%";
                }
            },
            fetchUnit(id) {
                apis.protectedApi(`${urls.apiBaseUrl}Contract/AditionalTriggerData/${id}`).then(it => {
                    this.contractUnits = it.data.units;
                    this.riskManager = it.data.riskManager;
                }
                ).catch(
                    response => {
                        var message = response.response.data.message != undefined ? response.response.data.message : "Error invoking service,please contact support";
                        gridOptions.errorAlert("Error: " + message);
                    }
                );

            },
            fetchCheckPrice(contractId, requestType) {
                if (contractId != null) {
                    apis.protectedApi(`${urls.apiBaseUrl}PricingArea/checkPriceArea/${contractId}`).then(it => {

                        if (it.data == true) {
                            if (requestType === "beginEdit") {
                                dpPriceArea.enabled = false;
                            }
                            else {
                                dpPriceArea.enabled = true;
                            }
                            var column = this.$refs.grid.getColumnByField("pricingAreaId");
                            column.validationRules.required = true;

                        } else {
                            dpPriceArea.enabled = false;
                            var column = this.$refs.grid.getColumnByField("pricingAreaId");
                            column.validationRules.required = false;
                            console.log(document.getElementById('pricingAreaId_Error'));
                            document.getElementById('pricingAreaId_Error').style = "display:none";
                        }
                    }
                    ).catch(
                        response => {
                            var message = response.response.data.message != undefined ? response.response.data.message : "Error invoking service,please contact support";
                            gridOptions.errorAlert("Error: " + message);
                        }
                    );
                }
            }
        },
        created: function () {
        },
        provide: {
            grid: [Page, Edit, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey, CommandColumn]
        }
    };

</script>
<style>

    .greenBox {
        background-color: #7FB7BE !important;
        color: #7FB7BE;
    }

    .redBox {
        background-color: #f78764 !important;
        color: #f78764;
    }

    #container {
        height: 350px;
    }

    .e-float-input.e-control-wrapper .e-float-text::after {
        content: '*';
        color: red;
        margin-left: 4px;
    }
    [id$="notifyEmailAddresses"]::after {
        content: '' !important;
    }
</style>
